import {
  type OrderCompetitionsPayload,
  type Match,
  type CreateMatchPayload,
  type EditMatchPayload,
  type EditCompetitionPayload,
  type ServerUpdateAllPayload,
  type addHomeWidgetPayload,
} from '@/slices/matches/types';
import { makeRequestActionCreator } from '@/utils';
import { matchesSlice } from './slice';

const createRequestAction = makeRequestActionCreator(matchesSlice.name);

export const tryFetchDailyMatches = createRequestAction<string, Match[]>(
  'tryFetchDailyMatches',
);

export const fetchDailyMatches = createRequestAction<string, Match[]>(
  'fetchDailyMatches',
);

export const orderCompetitions =
  createRequestAction<OrderCompetitionsPayload[]>('orderCompetitions');

export const createMatch =
  createRequestAction<CreateMatchPayload>('createMatch');

export const editMatch = createRequestAction<EditMatchPayload>('editMatch');

export const editCompetition =
  createRequestAction<EditCompetitionPayload>('editCompetition');

export const serverUpdateAll =
  createRequestAction<ServerUpdateAllPayload | null>('serverUpdateAll');

export const addLiveBlog = createRequestAction<Match['id']>('addLiveBlog');

export const addHomeWidget =
  createRequestAction<addHomeWidgetPayload>('addHomeWidget');

export const syncMatchData = createRequestAction<Match['id']>('syncMatchData');

export const {
  setDailyMatches,
  clearDailyMatches,
  clearAll,
  setSelectedDate,
  setSelectedSport,
  setSelectedCompetition,
  localUpdateMatch,
  localUpdateCompetition,
} = matchesSlice.actions;
